import classnames from 'classnames';
import React from 'react';
import { FormattedMessage, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { ButtonIcon } from 'src/app/components/Button/ButtonIcon';
import { IconAddToList } from 'src/app/components/Icon/IconAddToList';
import { IconContent } from 'src/app/components/Icon/IconContent';
import { IconList } from 'src/app/components/Icon/IconList';
import { IconStream } from 'src/app/components/Icon/IconStream';
import { Tooltip } from 'src/app/components/Tooltip/Tooltip';
import { EventTrack, pushEventTracking } from 'src/app/helpers/analytics';
import { withIntl } from 'src/app/helpers/locale';
import { withPopupPlaylist } from 'src/app/helpers/popup';
import { withStyles } from 'src/app/helpers/styles';
import { Playlist } from 'src/app/models/playlist';
import { InjectedPopupPlaylistProps } from 'src/app/models/popup';

type MyInjectedProps = InjectedPopupPlaylistProps & InjectedIntlProps;

interface MyOwnProps {
  id: string;
  isInWatchlist: boolean;
  onWatchlistButtonClick?: VoidFunction;
  inPlaylists: Playlist[];
  userPlaylists: Playlist[];
  className?: string;
  addToPushEventTrack?: EventTrack;
}

interface MyState {
  showAddToPopup: boolean;
}

type MyProps = MyOwnProps & MyInjectedProps;

@withIntl()
@withPopupPlaylist()
@withStyles(require('./PlaylistAddtoMenu.scss'))
class MyClassPlaylistAddtoMenu extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props);

    this.state = {
      showAddToPopup: false
    };

    this.toggleAddToMenu = this.toggleAddToMenu.bind(this);
    this.toggleAddToPlaylistPopup = this.toggleAddToPlaylistPopup.bind(this);
  }

  render(): JSX.Element {
    const { intl: { formatMessage }, className } = this.props;
    return (
      <>
        <div onMouseLeave={() => this.setState({ showAddToPopup: false })} className={classnames('pl-2 pt-2 radius-small', className)}>
          <ButtonIcon
            icon={IconAddToList}
            modifier="clear"
            onClick={this.toggleAddToMenu}
            data-delay-show="500"
            data-effect="solid"
            data-place="left"
            data-tip={formatMessage({ id: 'tooltip.add.to' })}
          />
          {this.state.showAddToPopup && this.renderAddToMenu}
        </div>
        <Tooltip />
      </>
    );
  }

  private get renderAddToMenu(): JSX.Element {
    const { isInWatchlist, onWatchlistButtonClick } = this.props;
    return (
      <div className="fs-14 lh-1 p-16 bg-black-light position-absolute playlist-addtomenu" >
        <div className="mb-8 fg-gray-light">
          <FormattedMessage id="label.add.to" />
        </div>
        <div className="cursor-pointer fg-gray-light">
          {!isInWatchlist && onWatchlistButtonClick &&
            <div onClick={onWatchlistButtonClick} className="mb-8 playlist-addtomenu__item">
              <IconContent classNameIcon="fs-14" icon={IconStream}>
                <FormattedMessage id="label.add.to.watchlist" />
              </IconContent>
            </div>
          }
          <div onClick={this.toggleAddToPlaylistPopup} className="mb-8 playlist-addtomenu__item">
            <IconContent classNameIcon="fs-14" icon={IconList}>
              <FormattedMessage id="label.add.to.playlist" />
            </IconContent>
          </div>
        </div>
      </div>
    );
  }

  private toggleAddToPlaylistPopup(): void {
    this.props.showPopupPlaylist(
      this.props.id,
      this.props.isInWatchlist,
      this.props.inPlaylists,
      this.props.userPlaylists,
      this.props.addToPushEventTrack
    );
  }

  private toggleAddToMenu(): void {
    this.setState({ showAddToPopup: !this.state.showAddToPopup });
    if (!this.state.showAddToPopup && this.props.addToPushEventTrack) {
      pushEventTracking(
        this.props.addToPushEventTrack['eventDetails.category'],
        this.props.addToPushEventTrack['eventDetails.action'],
        this.props.addToPushEventTrack['eventDetails.label'],
        this.props.addToPushEventTrack.custom
      );
    }
  }
}

export const PlaylistAddtoMenu = MyClassPlaylistAddtoMenu as React.ComponentClass<MyOwnProps>;
